module.exports = __webpack_public_path__ + "img/banner_20240322111659.3154a83a.jpg";